import * as OvationsApi from 'core/ovations-api';
import { range } from 'lodash';
import { mockBatchConfiguration } from './batchConfiguration';
import { emptyPlatformUserProfile } from './platformUserProfile';

const batchStatusEnumCount = Object.keys(OvationsApi.Enums.BatchStatus).length / 2;

export const mockBatchList: OvationsApi.Types.Batch[] = range(0, 7).map((i) => ({
    id: `_id__${i}`,
    number: i,
    configuration: mockBatchConfiguration,
    status: OvationsApi.Enums.BatchStatus[i % batchStatusEnumCount] as OvationsApi.Enums.BatchStatus,
    createDate: `2018-0${i}-20T20:00:08.734Z`,
    lastUpdate: `2018-0${i}-20T20:00:08.734Z`,
}));

const lightlyPopulatedProfile: OvationsApi.Types.PlatformUserProfile = {
    ...emptyPlatformUserProfile,
    firstName: 'TestFirstName',
    lastName: 'TestLastName',
};

export const mockBatchActivity: OvationsApi.Types.BatchActivity[] = [
    {
        date: '2018-09-20T20:00:08.734Z',
        oldStatus: OvationsApi.Enums.BatchStatus.Created,
        newStatus: OvationsApi.Enums.BatchStatus.VerifyingFunds,
        user: null,
    },
    {
        date: '2018-10-21T20:00:08.734Z',
        oldStatus: OvationsApi.Enums.BatchStatus.VerifyingFunds,
        newStatus: OvationsApi.Enums.BatchStatus.AwaitingFunding,
        user: null,
    },
    {
        date: '2018-11-22T20:00:08.734Z',
        oldStatus: OvationsApi.Enums.BatchStatus.AwaitingFunding,
        newStatus: OvationsApi.Enums.BatchStatus.FundingApproved,
        user: lightlyPopulatedProfile,
    },
];

export const mockPromotionBatchSummaries: OvationsApi.Types.PromotionBatchSummary[] = range(0, 4).map((i) => ({
    numberNewCards: i,
    totalNewCards: i,
    promotion: `Test-Promotion-${i}`,
    rewardPackage: `Test_Reward-Package-${i}`,
    faceValue: i,
    otherFees: i,
    fulfillmentFees: i,
    feeAmount: i,
    totalAmount: i,
    numberNewChecks: i,
    totalNewChecks: i,
}));

export const mockBatchDetails: OvationsApi.Types.BatchDetails = {
    newCardTotal: 400,
    newCardCount: 42,
    reloadCount: 4,
    reloadTotal: 1000,
    newCheckCount: 0,
    newCheckTotal: 0,
    totalFaceValue: 1400,
    fulfillmentFees: 100,
    otherFees: 1000,
    fundingTotal: 2000,
    activity: mockBatchActivity,
    promotionSummaries: mockPromotionBatchSummaries,
    id: 'batch-1',
    number: 4,
    configuration: mockBatchConfiguration,
    status: OvationsApi.Enums.BatchStatus.FundingApproved,
    createDate: '2018-09-20T20:00:08.734Z',
    createdBy: 'first last',
};

export const mockBatchCustomerList: OvationsApi.Types.BatchCustomer[] = range(0, 7).map((i) => ({
    id: `_id__${i}`,
    totalAmount: i,
    name: `_name__${i}`,
    email: `_email__${i}`,
}));

export const mockBatch = mockBatchList[0];
